<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
					<div class="btn-group enrollment-list-btn-info" role="group">
						<div *ngFor="let status of enrollment_status" >
							<button  id="status-btns" type="button" class="btn"
							[ngClass]="{'btn-primary': status?.name ==='Pending' || status?.name ==='Classroom' || status?.name ==='Online' || status?.name ==='Completed' ,'btn-outline-primary':activeTab !==status?.name && activeTab !==status?._id }"
							(click)="activeOnboardingTab(status.name,status?._id)">{{status?.name}}</button>
						  </div>
					  <!-- <button class="btn enrollment-list-buttons cursor-pointer" type="button"
						*ngFor="let status of statusList"
						[ngClass]="{'btn-primary':activeTab===status?.id,'btn-outline-primary':activeTab!==status?.id}"
						(click)="activeOnboardingTab(status?.id)">{{status.name}}</button> -->
						<!-- <ng-select [items]="performer_list" bindLabel="name" bindValue="_id" placeholder="Select performer"
							[(ngModel)]="selected_performer" [ngModelOptions]="{ standalone: true }"
							(change)="getPerformerId($event)">
						</ng-select> -->
					</div>
				  </div>
				  
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
					<div class="row-flex">
						<div class="col-flex-2 mb-1 position-relative">
							<input id="ngx-filter-ref"
							  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
							  type="text" placeholder="Search" #name (keydown.enter)="filter(searchVal)"
							  [(ngModel)]="searchVal" />
							<button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
							  <i class="ft-search text-white cursor-pointer"></i>
							</button>
						  </div>
						  <div class="col-flex-2 mb-1">
							<button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
							  Reset
							  <i class="ft-filter text-white cursor-pointer"></i>
							</button>
						  </div>
					  <div class="col-flex-2 mb-1"
						*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
						<!-- <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  routerLink="/tags/tag-create" placement="top" ngbTooltip="Add New">
						  +
						</button> -->
					  </div>
					</div>
				  </div>
				  
				</div>
				<div>
					<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
					[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
					[count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				</div>
			  </fieldset>
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Name" prop="student_id" [width]="60">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <div class="cell-line-height cursor-pointer">
						<p class="font-medium-1 line-height-1 mb-0">
						  {{ row?.student_id[0]?.name || row?.student_user[0]?.name }}
						</p>
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="About" prop="about" [width]="120">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p style="overflow-wrap: anywhere !important">{{row?.about}}</p>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Resume" prop="resume" [width]="70">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div *ngIf="row?.resume!=='undefined'" style="overflow-wrap: anywhere !important">
							<span >{{row?.resume}}</span>
							<a  [href]="row?.resume" target="_blank">
								<i class="ft-external-link text-primary cursor-pointer mx-1" [hidden]="!row?.resume" placement="left"
								ngbTooltip="Go to resume link : {{row?.resume}}"></i>
							</a>
						</div>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="LinkdIn" prop="linkedIn	" [width]="70">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<div *ngIf="row?.resume!=='undefined'" style="overflow-wrap: anywhere !important">
							{{row?.linkedIn}}
							<a (click)="gotoLink(row?.linkedIn)">
								<i class="ft-external-link text-primary cursor-pointer mx-1" [hidden]="!row?.linkedIn" placement="left"
								  ngbTooltip="Go to linkdIn link : {{row?.linkedIn}}"></i>
							</a>
						</div>
						
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Student Empowerment" prop="is_interestd	" [width]="40">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<mat-slide-toggle color="primary" [checked]="row?.is_interested"
						 ></mat-slide-toggle>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Status" prop="status" [width]="40">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<p [matMenuTriggerFor]="status">
						  <span *ngIf="row?.status === 'approved'"
							[ngClass]="{'bg-light-success badge badge-pill cursor-pointer':row?.status === 'approved'}">
							{{row?.status}}
						  </span>
						  <span *ngIf="row?.status === 'not-approved'"
							[ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':row?.status === 'not-approved'}">
							{{row?.status}}
						  </span>
						  <span *ngIf="row?.status === 'pending'"
							[ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':row?.status === 'pending'}">
							{{row?.status}}
						  </span>
						</p>
						<mat-menu #status="matMenu">
	
						  <div >
							<div *ngFor="let status of statusList">
							  <button mat-menu-item *ngIf="status?.id !== row?.status "
								(click)="updateStatus(row?._id,status.id)">
								<span>
								  <span [ngClass]="{'bg-light-success badge badge-pill cursor-pointer':status.name === 'Approved'}"
									placement="top" *ngIf="status.name === 'Approved'">{{status.id}}</span>
								  <span [ngClass]="{'bg-light-warning badge badge-pill cursor-pointer':status.name === 'Not Approved'}"
									placement="top" *ngIf="status.name === 'Not Approved'">{{status.id}}</span>
								  <span [ngClass]="{'bg-light-danger badge badge-pill cursor-pointer':status.name === 'Pending'}"
									placement="top"
									*ngIf="status.name === 'Pending'">{{status.id}}</span>
								</span>
							  </button>
							</div>
						  </div>
						</mat-menu>
				  </ng-template>
				</ngx-datatable-column>
				
				<ngx-datatable-column name="Actions" [width]="50"
				  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/onboarding-reports/add-edit', row._id]"></i>
					
				  </ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>
  
  